<template>
  <div class="bg-slate-900 rounded-xl overflow-hidden shadow-sm cf-live-preview">
    <div class="px-4 py-3 border-b border-slate-700 flex flex-wrap items-center justify-between gap-3">
      <div>
        <p class="m-0 text-xs font-bold uppercase tracking-wide text-slate-300">Live preview</p>
        <span class="text-xs text-slate-400">Matches preview page</span>
      </div>
      <div class="flex items-center gap-1 bg-slate-800 rounded-lg p-1">
        <button
          type="button"
          class="px-3 py-1 text-xs font-semibold border-0 rounded cursor-pointer transition-colors duration-200"
          :class="previewMode === 'desktop' ? 'bg-six text-white' : 'bg-transparent text-slate-300'"
          @click="setMode('desktop')"
        >
          Desktop
        </button>
        <button
          type="button"
          class="px-3 py-1 text-xs font-semibold border-0 rounded cursor-pointer transition-colors duration-200"
          :class="previewMode === 'mobile' ? 'bg-six text-white' : 'bg-transparent text-slate-300'"
          @click="setMode('mobile')"
        >
          Mobile
        </button>
      </div>
    </div>

    <div ref="viewport" class="cf-live-preview-viewport">
      <div v-if="hasContent" class="cf-live-preview-stage">
        <div
          class="cf-live-preview-shell"
          :class="previewMode === 'mobile' ? 'cf-live-preview-shell--mobile' : 'cf-live-preview-shell--desktop'"
          :style="shellStyle"
        >
          <div ref="frame" class="cf-live-preview-frame" :style="frameStyle">
            <CareerFairHeroBlock
              :layout="heroData.layout"
              :banner-url="heroData.bannerUrl"
              :banner-alt="heroData.title || 'Career fair banner'"
              :kicker="heroData.kicker"
              :title="heroData.title"
              :tagline="heroData.tagline"
              :hashtag="heroData.hashtag"
              :buttons="heroData.buttons"
              :circle-urls="heroData.circleUrls"
              :variant="previewMode"
              :interactive="false"
            />
          </div>
        </div>
      </div>
      <p v-else class="text-slate-400 text-sm py-16 text-center m-0 px-4">
        Nothing to preview yet. Add a title, banner, or portraits.
      </p>
    </div>
  </div>
</template>

<script>
import CareerFairHeroBlock from "../../career-fair/components/CareerFairHeroBlock.vue";

export default {
  name: "HeroLivePreview",
  components: { CareerFairHeroBlock },
  props: {
    heroData: {
      type: Object,
      default: function () {
        return {
          layout: "composed",
          bannerUrl: "",
          kicker: "",
          title: "",
          tagline: "",
          hashtag: "",
          buttons: [],
          circleUrls: [],
        };
      },
    },
  },
  data() {
    return {
      previewMode: "desktop",
      previewScale: 0.55,
      frameWidth: 1200,
    };
  },
  computed: {
    hasContent() {
      var d = this.heroData || {};
      if (d.layout === "banner" && d.bannerUrl) return true;
      return !!(
        d.kicker ||
        d.title ||
        d.tagline ||
        d.hashtag ||
        (d.buttons && d.buttons.length) ||
        (d.circleUrls && d.circleUrls.length)
      );
    },
    shellStyle() {
      return {
        width: Math.ceil(this.frameWidth * this.previewScale) + "px",
      };
    },
    frameStyle() {
      return {
        width: this.frameWidth + "px",
        zoom: this.previewScale,
      };
    },
  },
  watch: {
    previewMode: function () {
      this.frameWidth = this.previewMode === "mobile" ? 390 : 1200;
      var self = this;
      this.$nextTick(function () {
        self.updateScale();
      });
    },
    heroData: {
      deep: true,
      handler: function () {
        var self = this;
        this.$nextTick(function () {
          self.updateScale();
        });
      },
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(function () {
      self.updateScale();
    });
    window.addEventListener("resize", this.updateScale);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScale);
  },
  methods: {
    setMode(mode) {
      this.previewMode = mode;
    },
    updateScale() {
      var viewport = this.$refs.viewport;
      if (!viewport) return;
      var available = viewport.clientWidth - 24;
      if (available < 1) return;
      var scale = available / this.frameWidth;
      if (scale > 1) scale = 1;
      if (scale < 0.32) scale = 0.32;
      this.previewScale = Math.round(scale * 1000) / 1000;
    },
  },
};
</script>

<style scoped>
.cf-live-preview-viewport {
  padding: 1rem;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 16rem;
  max-height: 44rem;
  background: #0f172a;
}

.cf-live-preview-stage {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
}

.cf-live-preview-shell {
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 0.5rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.cf-live-preview-shell--desktop {
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.cf-live-preview-shell--mobile {
  border: 3px solid rgba(255, 255, 255, 0.12);
  border-radius: 1.25rem;
}

.cf-live-preview-frame {
  transform-origin: top left;
}
</style>
